export * from './confetti';
export * from './error-handler';
export * from './extract-image-src';
export * from './extract-university-id';
export * from './get-platform';
export * from './is-browser';
export * from './is-empty-arr';
export * from './load-yandex-map';
export * from './parse-subject-name';
export * from './remove-image-tag';
export * from './slugify';
export * from './strip-html-tags';
export * from './truncate-text';
export * from './use-back';
